export default __webpack_public_path__ + "static/media/b2.b59ff695.svg";